export const IFRAME_MESSAGE_TYPES = {
  GET_ACCESS_TOKEN_FROM_WORKSPACE: 'getAccessToken',
  GET_WORKSPACE_CURRENT_URL: 'getCurrentURL',
  SET_IFRAME_LOCATION_TO_WORKSPACE_URL: 'setIframeLocationToWorkspaceUrl',
  LOCATION_CHANGED: 'LocationChanged'
} as const;


export interface IframeMessage<T = any> {
  type: typeof IFRAME_MESSAGE_TYPES[keyof typeof IFRAME_MESSAGE_TYPES],
  messageData?: T
}
